(function() { window.GUID_090bcb65_dea9_4bcc_ba97_31a5e25ae8d8 = { getGuid: function() { return "090bcb65-dea9-4bcc-ba97-31a5e25ae8d8"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class MatchCardHistoryViewer extends Controls.ControlBase {
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return $(`#${this.controlId}`);
            }
            constructor(controlId, ...params) {
                super(controlId, ...params);
            }
            OnControlInstantiation(params) {
                this.controlId = params[0];
                this.matchId = params[1];
                this.loggingLevel = params[2];
                const limit = params[3];
                if (limit &&
                    limit != "null" &&
                    limit != "undefined" &&
                    !isNaN(parseInt(limit))) {
                    this.limit = limit;
                }
            }
            OnBindEvents() { }
            OnDispose() { }
            OnControlRendered() {
                try {
                    this.$Control.trigger(`ready`);
                    this.$parentLoggerControl = this.$Control.closest(".cs-match-card-history-logger");
                    if (this.$parentLoggerControl.length) {
                        this.$parentLoggerControl.offon(`ready.${this.ControlId}`, this.onParrentLoggerControlReady.bind(this));
                    }
                }
                catch (error) {
                    console.error("Error in OnControlRendered", error);
                }
            }
            addItem(item) {
                try {
                    CS.Helper.log("MatchCardHistoryViewer", "Adding item...");
                    const $itemsContainer = this.$Control.find(".live-value-history-items");
                    $itemsContainer.prepend(item);
                    CS.Helper.log("MatchCardHistoryViewer", `Successfully added item`);
                }
                catch (error) {
                    console.error("Error while adding item", error);
                }
            }
            onParrentLoggerControlReady() {
                try {
                    if (!this.$parentLoggerControl.length) {
                        return;
                    }
                    const mostRecentItem = this.getMostRecentItem();
                    this.$parentLoggerControl.trigger(`historyViewerReady`, [
                        mostRecentItem,
                    ]);
                }
                catch (error) {
                    console.error("Error while handling parent logger control ready", error);
                }
            }
            getItemsMarkups() {
                try {
                    const markups = [];
                    const $items = this.$Control.find(".live-value-history-item");
                    if (!$items.length) {
                        return markups;
                    }
                    $items.each((index, element) => {
                        const markup = this.getItemMarkup(index);
                        if (markup) {
                            markups.push(markup);
                        }
                    });
                    return markups;
                }
                catch (error) {
                    console.error("Error while getting items", error);
                }
            }
            getItemMarkup(index) {
                try {
                    const $item = this.$Control.find(`.live-value-history-item:eq(${index})`);
                    if (!$item.length) {
                        return null;
                    }
                    return $item.html();
                }
                catch (error) {
                    console.error("Error while getting item", error);
                }
            }
            getMostRecentItem() {
                try {
                    return this.getItemMarkup(0);
                }
                catch (error) {
                    console.error("Error while getting most recent item", error);
                }
            }
        }
        Controls.MatchCardHistoryViewer = MatchCardHistoryViewer;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=match-card-history-viewer.js.map
